<template>
  <V2AtomsBaseCard
    radius="small"
    class="flex flex-col justify-between border-semantic-util-transparent text-left gap-2 md:gap-4 h-fit shadow-combined-elevation-1"
    :class="wrapperClass"
    :data-testid="dataTestid"
  >
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="review || title || subTitle"
      class="flex flex-col md:gap-2 gap-1"
    >
      <V2AtomsBaseStars
        :review="review"
        :fill="semanticColorLookup('primary.default')"
      />

      <div
        v-if="title"
        class="font-semibold text-semantic-surface-on-surface md:text-2xl/[120%] text-lg/[120%] line-clamp-1 text-ellipsis"
      >
        {{ title }}
      </div>

      <div
        v-if="subTitle"
        class="text-semantic-surface-on-surface md:text-base/[150%] text-sm/[150%]"
      >
        {{ subTitle }}
      </div>

      <div
        v-if="description"
        class="text-semantic-surface-on-surface md:text-base/[150%] text-sm/[150%] line-clamp-2 text-ellipsis min-h-fit"
      >
        {{ description }}
      </div>
    </div>

    <div v-if="ctaBtnLabel">
      <div class="flex justify-end items-end grow">
        <V2AtomsButton
          theme="tertiary"
          :to="ctaBtnTo"
          :target="ctaBtnTarget"
        >
          {{ ctaBtnLabel }}
          <template #icon-right="{ iconClass }">
            <IconsArrowUpRight
              :class="iconClass"
              :fill="semanticColorLookup('primary.default')"
            />
          </template>
        </V2AtomsButton>
      </div>
    </div>
  </V2AtomsBaseCard>
</template>

<script setup>
defineOptions({
  name: 'V2MoleculesReviewsFeatureReviewCard'
})

defineProps({
  dataTestid: {
    type: String,
    default: 'reviews-feature-review-card'
  },

  title: {
    type: String,
    default: ''
  },

  subTitle: {
    type: String,
    default: ''
  },

  review: {
    type: Number,
    default: 1,
    validator: val => val >= 1 && val <= 5
  },

  description: {
    type: String,
    default: ''
  },

  wrapperClass: {
    type: String,
    default: ''
  },

  ctaBtnLabel: {
    type: String,
    default: ''
  },

  ctaBtnTo: {
    type: String,
    default: ''
  },

  ctaBtnTarget: {
    type: String,
    default: ''
  }
})
</script>
